import BaseModule from './BaseModule.js';

class PixInfraction extends BaseModule {
  async paginate({
    page = 1,
    per_page = 20,
    provider = null,
    status = null,
    classification = null,
    infraction_type = null,
    term = null,
  }) {
    return await this.get('back-office/pix_infractions', {
      params: { page, per_page, provider, status, classification, infraction_type, term },
    });
  }

  async fetch(id) {
    return await this.get(`back-office/pix_infractions/${id}`);
  }

  async updateClassification(id, { classification, internal_notes }) {
    return await this.patch(`back-office/pix_infractions/${id}/classification`, {
      classification,
      internal_notes,
    });
  }
}

export default PixInfraction;
